<template lang="html">
  <div class="cw-alert is-flex">
    <div class="centerit">
      <div class="centerit-body">
        <div class="cw-alert-box box is-padded-large">
          <div class="content has-text-centered">
            <div
              class="is-padded-medium"
              :class="{ 'has-border-bottom': message != null }"
            >
              <h3 class="title is-size-5">{{ title }}</h3>
              <p v-if="subtitle" class="subtitle is-size-6">{{ subtitle }}</p>
            </div>
            <div v-if="message" class="is-padded-medium">
              <p class="is-size-6">{{ message }}</p>
            </div>
          </div>
          <div class="status-icon is-large" :class="statusIconClasses">
            <span class="icon">
              <i class="la" :class="[statusIconName]"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="columns centered">
      <a
        v-for="(action, index) in actions"
        :key="index"
        class="column button is-large is-rounded"
        :class="action.classes"
        @click="handleAction(action)"
        >{{ action.title }}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'cw-alert',
  // share common functionality with component mixins
  mixins: [],
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    subtitle: {
      type: String,
      required: false,
    },
    message: {
      type: String,
      required: false,
    },
    actions: {
      type: Array,
      required: false,
      default: () => [
        {
          title: 'Ok',
          classes: ['is-black'],
        },
      ],
    },
    type: {
      type: String,
      required: false,
      default: 'success',
    },
  },
  computed: {
    statusIconClasses() {
      let typeClass = `is-${this.type}`;
      return [typeClass];
    },
    statusIconName() {
      switch (this.type) {
        case 'success':
          return 'la-check';
        case 'warning':
          return 'la-exclamation-triangle';
        case 'danger':
          return 'la-cogs';
        default:
          return 'la-check';
      }
    },
  },
  methods: {
    handleAction(action) {
      if (action.callback) action.callback();
      else this.$modal.hide('alert');
    },
  },
};
</script>

<style lang="stylus" scoped>
.cw-alert {
  flex-direction: column;
  margin:auto;
  padding: 20px;
  max-width: 25em;
  overflow: visible;
  @media screen and (max-width 765px - 1px) and (max-height 765px) {
    height: 100vh;
  }
  .centerit {
    flex-grow: 1

    .centerit-body {
      max-width: 300pt
    }
  }

  .cw-alert-box {
    padding-bottom: 1rem
    margin-bottom: 4rem
    position: relative
    box-shadow: 0 10px 300.0px rgba(#100, 0.5)

    .status-icon {
      position: absolute
      bottom: -2.25rem
      left: calc(50% - 2.25rem - 2px)
      border-width: 4px
      border-color: white
    }
  }
}

.button.column {
  display: flex;
  margin: 0.7em;
}
</style>
